import React, { useState, useEffect } from 'react';
import TextArea from '../../common/components/TextArea/TextArea';
import styles from './DefaultTemplate.module.css';
import Stepper from '../../common/components/Stepper/Stepper';
import Button from '../../common/components/Button/Button';

const DefaultTemplate = ({
  userPrompt,
  onUserPromptChange,
  onApplyChanges,
  nodeType,
  workflowId,
}) => {
  const steps = [
    { label: 'Home', path: '/' },
    { label: 'Workflow', path: `/workflow/${workflowId}` },
    { label: nodeType, path: '' },
  ];
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (userPrompt && userPrompt.length > 0) {
      setIsVisible(false);
    }
  }, [userPrompt]);

  const handleApplyChanges = () => {
    onApplyChanges();
  };

  const showPrompt = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className={styles.container}>
      <Stepper steps={steps} workflowId={workflowId} />
      <TextArea
        label="Modify design with prompts"
        value={userPrompt}
        onChange={onUserPromptChange}
        placeholder="Describe additional changes (e.g., make h1 text larger)"
        showSuggestion={isVisible}
        onSuggestionToggle={showPrompt}
      />
      <div className={styles.prompts} onClick={showPrompt}>
        View sample prompts
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonGroup}>
          <Button label="Apply Changes" onClick={handleApplyChanges} />
        </div>
      </div>
    </div>
  );
};

export default DefaultTemplate;

